// Shared route targets for the marketing pages. Where the target is an existing
// app route, this points at what the app already uses elsewhere (see Header.js /
// Home.js). Items still marked TODO in the design brief are noted below.
export const HOME_ROUTE = '/';
export const CREATE_PAGE_ROUTE = '/pages/new';
export const HOW_TO_ROUTE = '/HowTo';
export const CONTACT_ROUTE = '/contact';
export const LOGIN_ROUTE = '/login';
export const VIDEOS_ROUTE = '/Videos';
export const VIDEOS_ANCHOR = '/#videos';
// TODO(site owner): confirm target — currently reuses the existing "Tell me how" link.
export const HELP_ROUTE = '/Help';
